import { select } from "redux-saga/effects";

import { writeToLocalStorage } from "common/utilities/localStorage";
import { getCoachmarksAreEnabled } from "domains/coachmarks/selectors";

export function* toggleCoachmarksSaga() {
  const isEnabled: ReturnType<typeof getCoachmarksAreEnabled> = yield select(getCoachmarksAreEnabled);
  writeToLocalStorage("COACHMARKS_VISIBILITY_STATUS", isEnabled);
}
